import styled from "styled-components";
import { flexBox } from "styles/mixins";

export const Splash = styled.div`
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.colors.primary.gradient};
  ${flexBox("center", "center")};
`;
